import Vue from 'vue'

const InterviewTableInstance = Vue.extend(require('./index.vue').default);
let instance = null
let interviewTablePromise = null
let interviewTableResolve = null

let getInstance = () => {
  return new InterviewTableInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (interviewTableResolve) {
    interviewTableResolve(false)
    interviewTableResolve = null
  }
  interviewTablePromise = null
}

let InterviewTable = (msg) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  interviewTablePromise = new Promise((resolve, reject) => {
    interviewTableResolve = resolve
  })
  instance.open(msg, interviewTableResolve)

  return interviewTablePromise
}

export default InterviewTable
